import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['fileInput', 'fileName', 'preview']

  update() {
    const file = this.fileInputTarget.files[0]

    if (!file) {
      this.fileNameTarget.textContent = ''
      return
    }

    this.fileNameTarget.textContent = file.name

    if (!file.type.startsWith('image/')) {
      return
    }

    const reader = new FileReader()
    reader.onload = (event) => {
      this.previewTarget.src = event.target.result
      this.previewTarget.classList.remove('is-hidden')
    }
    reader.readAsDataURL(file)
  }
}
